import React from "react";
import { useTranslation } from "react-i18next";
import { useAccounts, accountTypeKey } from "@/lib/AccountContext";
import { fmtMoney } from "@/lib/format";
import { Wallet, PiggyBank, TrendingUp } from "lucide-react";

const ICONS = { checking: Wallet, savings: PiggyBank, yield: TrendingUp };

export function AccountSwitcher() {
  const { t } = useTranslation();
  const { accounts, selectedId, setSelectedAccountId } = useAccounts();
  if (!accounts || accounts.length <= 1) return null;

  return (
    <div className="flex gap-2 flex-wrap" data-testid="account-switcher">
      {accounts.map((a) => {
        const I = ICONS[a.account_type] || Wallet;
        const active = a.id === selectedId;
        const name = a.label || t(accountTypeKey(a.account_type));
        return (
          <button
            key={a.id}
            onClick={() => setSelectedAccountId(a.id)}
            data-testid={`account-pill-${a.id}`}
            className={`group flex items-center gap-3 px-4 py-2.5 rounded-2xl border transition-all text-left ${
              active
                ? "border-blue-600 bg-blue-50 shadow-[0_8px_24px_-10px_rgba(37,99,235,0.5)]"
                : "border-slate-200 bg-white hover:border-blue-300"
            }`}
          >
            <span className={`w-9 h-9 rounded-xl flex items-center justify-center shrink-0 ${active ? "bg-blue-600 text-white" : "bg-slate-100 text-slate-600"}`}>
              <I size={16} />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-semibold text-slate-900 truncate">{name}</span>
              <span className="block text-[11px] font-mono-fin text-slate-500">{fmtMoney(a.balance, a.currency)}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
